export default "/assets/b871ad6e5cbe2a1c8c7362c81a234f93.woff2";